<template>
  <div class="introduction">
    <img class="promotion-header" :src="require(`@/assets/${this.promotionDetails.header}`)"/>
    <div class="intake-container">
      <div class="title">{{ this.promotionDetails.title }}</div>
      <div class="greeting">למימוש ההטבה והרשמה לשירות:</div>
      <enter-details :action="generateCodeAndProceed"
                     :error="serverErrors.generateCode"
                     :reset-error="() => resetError('generateCode')"/>

      <div class="promotion-details">
        <div class="details-title">{{ this.promotionDetails.detailsTitle }}</div>
        <div class="detail" v-for="detail in this.promotionDetails.details" :key="detail">
          <img class="check" :src="require('@/assets/icons/check_mark.svg')"/>
          {{ detail }}
        </div>
      </div>
      <div class="privacy-message">לעולם לא נמסור את הפרטים שלך לאף צד שלישי.</div>
      <support-footer/>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import BaseUI from 'base-ui';
import EnterDetails from '@/base-components/EnterDetails.vue';
import Segment from '../../../../../../Segment';
import promotionConsts from '../../../../../../constants/promotions';

export default {
  name: 'IntroductionWithPromo',
  components: {
    EnterDetails,
    SupportFooter: BaseUI.SupportFooter,
  },
  data() {
    return {
      PROMOTION_DETAILS: {
        [promotionConsts.PROMOTION_NAMES.BAT_YAM]: {
          header: 'promotions/bat-yam/batyam-header.svg',
          title: 'בת-ימים, הרשמו ותהנו מחודשיים ראשונים בשירות חינם!',
          detailsTitle: 'עוד על ההטבה לתושבי בת-ים:',
          details: [
            'חודש ראשון נסיון חינם',
            'חודש שני מתנה מעירית בת-ים',
            'משלמים רק מהחודש השלישי לשימוש, ₪45 לחודש',
            'לא צריך למסור פרטי אשראי עד לסוף תקופת הנסיון',
            'אפשר לבטל את המנוי בכל שלב',
          ],
        },
      },
    };
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('RegistrationEntered');
    Segment.trackUserGotToPixel('RE');
  },
  computed: {
    ...mapState('signup', ['phoneNumber', 'firstName', 'lastName', 'serverErrors', 'email', 'enableMarketingEmails']),
    ...mapState('promotions', ['promotion']),
    promotionDetails() {
      return this.PROMOTION_DETAILS[this.promotion];
    },
  },
  methods: {
    ...mapActions('signup', ['generateCode']),
    ...mapMutations('signup', ['setFirstName', 'setLastName', 'setPhoneNumber', 'resetError', 'setEmail', 'setEnableMarketingEmails']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      await this.setEmail(email);
      await this.setEnableMarketingEmails(enableMarketingEmails);
      Segment.trackUserInteraction('GenerateCodeClicked', {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
      });
      await this.generateCode();
      this.next();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';

.introduction {
  @include white-page-frame;
  font-family: SimplerPro;

  .promotion-header {
    width: 100%;
  }

  .intake-container {
    @include responsive-padding;
    margin-top: 30px;

    .generate-code-button {
      width: 100%;
    }

    .title {
      font-weight: bold;
      font-size: 22px;
      line-height: 1.36;
      display: inline-block;
      width: 100%;
      margin-bottom: 10px;
    }

    .greeting {
      font-size: 20px;
      color: $riseup_black;
      line-height: 1.5em;
      margin-bottom: 32px;

      .wa-verification {
        font-weight: bold;
      }
    }

    .promotion-details {
      border-radius: 8px;
      background-color: #FEF7E3;
      padding: 24px;
      font-size: 16px;
      line-height: 1.38;

      .details-title {
        font-weight: bold;
        margin-bottom: 20px;
      }

      .detail {
        display: flex;
        align-items: flex-start;
        &:not(:last-child) {
          margin-bottom: 20px;
        }
        .check {
          margin-left: 10px;
        }
      }
    }

    .privacy-message {
      font-size: 16px;
      color: $riseup_black;
      line-height: 24px;
      margin: 30px 0 15px;
    }
  }
}

</style>
